
export const PROGRAM_STRUCTURE_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    subject_name: "Introduction to Programming",
    credits: 3,
    priority: 1,
  },

  PROGRAM_STRUCTURE_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Program Structure Section Title",
      value: "Program Structure",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Program Structure Section Title",
      required: false,
      defaultValue: "Program Structure",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "image",
      label: "Program Structure Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload program structure image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_image",
      label: "Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter image alt text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "container_background_color",
      label: "Container Background Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter container background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_button_text",
      label: "CTA Button Text",
      value: "Learn More",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA button text",
      required: false,
      defaultValue: "Learn More",
    },
    {
      fieldName: "cta_button_text_color",
      label: "CTA Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_button_color",
      label: "CTA Button Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA button color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "cta_button_icon",
      label: "CTA Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload CTA button icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_button_icon_alt",
      label: "CTA Button Icon Alt Text",
      value: "Learn more",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA button icon alt text",
      required: false,
      defaultValue: "Learn more",
    },
    {
      fieldName: "header_section_color",
      label: "Header Section Color",
      value: "#F5F5F5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter header section color (e.g., #F5F5F5)",
      required: false,
      defaultValue: "#F5F5F5",
    },
    {
      fieldName: "subject_container_color",
      label: "Subject Container Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter subject container color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Program Structure Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Program Structure Section",
      required: false,
      defaultValue: false,
    },
  ],

  // Semester fields configuration for Form_3
  SEMESTER_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Semester Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter semester name (e.g., Semester 1, Semester 2)",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "name_color",
      label: "Name Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter name color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "section_color",
      label: "Section Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter section color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "selected_section_color",
      label: "Selected Section Color",
      value: "#E8E8E8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter selected section color (e.g., #E8E8E8)",
      required: false,
      defaultValue: "#E8E8E8",
    },
    {
      fieldName: "selected_section_bar_color",
      label: "Selected Section Bar Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter selected section bar color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "header_text_1",
      label: "Header Text 1",
      value: "Subject",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter header text 1 (e.g., Subject)",
      required: false,
      defaultValue: "Subject",
    },
    {
      fieldName: "header_text_1_color",
      label: "Header Text 1 Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter header text 1 color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "header_text_2",
      label: "Header Text 2",
      value: "Credits",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter header text 2 (e.g., Credits)",
      required: false,
      defaultValue: "Credits",
    },
    {
      fieldName: "header_text_2_color",
      label: "Header Text 2 Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter header text 2 color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "priority",
      label: "Display Order",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display order (1, 2, 3...)",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status",
      label: "Semester Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable semester",
      defaultValue: true,
    },
  ],

  // Subject table fields configuration for Form_3
  SUBJECT_TABLE_FIELDS_CONFIG: [
    {
      header: "Subject Name",
      fieldName: "subject_name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter subject name",
      required: true,
    },
    {
      header: "Subject Name Text Color",
      fieldName: "subject_name_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter subject name text color (e.g., #000000)",
      required: false,
    },
    {
      // Optional. Blank (not 0) is the default so a program without credits does not
      // have to type a placeholder number — leave it empty and ProgramStructure1 drops
      // the Credits column for that semester. `value: ""` matters: a numeric default
      // would pre-fill every new subject with 0 and render as a literal "0".
      header: "Credits",
      fieldName: "credits",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter credits (optional)",
      required: false,
    },
    {
      header: "Credits Text Color",
      fieldName: "credits_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter credits text color (e.g., #000000)",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter priority (1, 2, 3...)",
      required: true,
    },
  ],
};

